import type {
  BeginRegistrationDTO,
  FinalizeLoginDTO,
  FinilizeVerifyDTO,
  InitLoginDTO,
  InitRegistrationDTO,
  LoginDTO,
  LoginResult,
  RecoveryVerificationDTO,
  VerificationDTO,
} from '@/types/DTOs';

export abstract class AuthService {
  /* ─── Login / Logout ─── */
  abstract login(data: LoginDTO): Promise<LoginResult>;
  abstract logout(): Promise<void>;
  abstract initLogin(data: { username: string; ke1: string }): Promise<InitLoginDTO>;
  abstract finalizeLogin(data: { sessionId: string; ke3: string }): Promise<FinalizeLoginDTO>;
  abstract forgotPassword(data: { emailAddress: string }): Promise<void>;

  /* ─── Registration wizard ─── */
  abstract beginRegistration(data: { username: string; otp: string }): Promise<BeginRegistrationDTO>;
  abstract setPassword(data: { username: string; password: string }): Promise<void>;
  abstract confirmEmail(data: { code: string }): Promise<void>;
  abstract sendEmailCode(): Promise<VerificationDTO>;
  abstract resendEmailCode(): Promise<VerificationDTO>;
  abstract confirmPhone(data: { code: string }): Promise<{ message: string }>;
  abstract sendPhoneCode(): Promise<VerificationDTO>;
  abstract resendPhoneCode(): Promise<VerificationDTO>;
  abstract initRegistration(data: { username: string; registrationRequest: string }): Promise<InitRegistrationDTO>;
  abstract finalizeRegistration(data: { sessionId: string; registrationRecord: string }): Promise<void>;
  abstract resendRegistrationOtp(data: { username: string }): Promise<void>;

  /* ─── Two-Factor after password login ─── */
  abstract selectTwoFactorMethod(data: { method: 'sms' | 'email'; twoFactorToken: string }): Promise<VerificationDTO>;
  abstract verifyTwoFactorCode(data: { code: string; twoFactorToken: string }): Promise<FinilizeVerifyDTO>;
  abstract resendTwoFactorCode(data: { method: 'sms' | 'email'; twoFactorToken: string }): Promise<VerificationDTO>;

  abstract verifyRecoveryOtp(data: { emailAddress: string; code: string }): Promise<RecoveryVerificationDTO>;
  abstract sendRecoveryTwoFactor(data: { recoveryToken: string }): Promise<VerificationDTO>;
  abstract verifyRecoveryTwoFactor(data: { recoveryToken: string; code: string }): Promise<void>;
}
